module.exports = "<div class=\"search-tool-stage {{ theme | themeClass }}\"> <slot></slot> <div v-if=inputDisplay class=input-stage> <icon name=search></icon> <input-box :placeholder=placeholder :query-name=queryName @keyup.enter=search></input-box> </div> <a v-if=searchBtnDisplay class=\"btn btn-danger search-btn\" @click=search>{{btnTxt}}</a> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/common/search-tool/search-tool.tpl
// module id = 957
// module chunks = 2